<div class="card-layout">
  <div class="card-layout__inner">
    <div class="card-layout__grid">
      <p-card class="card-layout__card">
        <div
          class="card-layout__router-outlet"
          [@routeTransitions]="
            outlet && outlet.activatedRouteData && outlet.activatedRouteData['animationComponentName']
          "
        >
          <router-outlet #outlet="outlet"></router-outlet>
        </div>
      </p-card>
    </div>
  </div>
  <app-toast-container
    class="main-layout__toast-container"
    (buttonClick)="onToastButtonClick($event)"
    (dismiss)="onToastDismiss($event)"
  ></app-toast-container>
</div>
